import React, { useState, useEffect } from "react";
// import { withRouter } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import language from "../../../language";
import CircularProgress from "@mui/material/CircularProgress";

//scss
import "./Checkout.scss";

//mui
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import TextField from "@mui/material/TextField";

//icons
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import { SERVER_URL } from "../../../ServerUrl";
import {
  ResetBookingInfo,
  SetCompletedBooking,
} from "../../../actions/bookings";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { updateOperatorWalletBalance } from "../../../Redux/userReducer";
import ApplyCouponUser from "./ApplyCouponUser";
import PackageBooking from "./PackageBooking";

//assets

const Checkout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const departureTripDetail = useSelector(
    (state) => state?.bookings?.bookingInfo
  );
  const isPackage = useSelector(
    (state) => state?.bookings?.bookingInfo?.isPackage
  );
  const totalPassenger = useSelector(
    (state) => state?.buses?.requesInfo?.totalPassenger
  );
  const loggedUser = useSelector(
    (state) => state?.userReducer?.userdataOperator?.user
  );
  const loggedUserId = useSelector(
    (state) => state?.userReducer?.userdataOperator?.user?._id
  );
  const requesInfo = useSelector((state) => state?.buses?.requesInfo);
  const oldbooking = useSelector((state) => state?.bookings?.oldBooking);
  const modifyTrip = useSelector(
    (state) => state?.buses?.requesInfo?.modifyTrip
  );
  const [walletPay, setWalletPay] = useState(false);
  const [savebooking, setSavebooking] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [appliedCouponCodes, setAppliedCouponCodes] = useState([]);
  const [bookingId, setBookingId] = useState();
  const [couponResponse, setCouponResponse] = useState({
    couponType: "",
    discount1: 0,
    discount2: 0,
    totalDiscount: 0,
  });
  const [bookingDetail, setBookingDetail] = useState(() => {
    if (isPackage) {
      const farePerPassenger =
        departureTripDetail?.packageAccom === "with"
          ? departureTripDetail?.packagePricewith
          : departureTripDetail?.packageAccom === "without"
          ? departureTripDetail?.packagePricewithOut
          : departureTripDetail?.packageAccom === "food"
          ? departureTripDetail?.packagePricewithfood
          : departureTripDetail?.packageAccom === "Visa"
          ? departureTripDetail?.packagePricewithVisaAccomfood
          : null;

      return {
        email: departureTripDetail?.passengerDetail?.email,
        phone: `${departureTripDetail?.passengerDetail?.cCode || ""}${
          departureTripDetail?.passengerDetail?.phone || ""
        }`,
        NoOfpassengers: requesInfo?.totalPassenger,
        passengerDetails: departureTripDetail?.passengerDetail?.passengers,
        totalFare: farePerPassenger * requesInfo?.totalPassenger, // example, adjust as per your package logic
        totalPaidAmount: farePerPassenger * requesInfo?.totalPassenger,
        type: requesInfo?.tripType,
        paymentMethod: "",
        ispaymentdone: "Yes",
        bookedBy: "Customer",
        UsedwalletBalance: 0,
        amountToPay: 0,
        totalCashbackDiscount: 0,
        totalPriceDiscount: 0,
        packageWithAccom: departureTripDetail?.packageAccom,
        packageId: departureTripDetail?.packageId,
        tripDetails: [
          {
            tripType: "Package",
            typeRef: "Package",
            tripId: departureTripDetail?.packageId,
            noOfSeats: requesInfo?.totalPassenger,
            seats: departureTripDetail?.departureTripSeats,
            originalPrice: farePerPassenger * requesInfo?.totalPassenger,
            price: farePerPassenger * requesInfo?.totalPassenger,
            appliedCoupons: [],
            totalCouponDiscount: 0,
            cashbackDiscount: 0,
            priceDiscount: 0,
          },
        ],
      };
    }

    // 🚌 If booking is for a normal trip
    return {
      email: departureTripDetail?.passengerDetail?.email,
      phone: `${departureTripDetail?.passengerDetail?.cCode || ""}${
        departureTripDetail?.passengerDetail?.phone || ""
      }`,
      NoOfpassengers: requesInfo?.totalPassenger,
      passengerDetails: departureTripDetail?.passengerDetail?.passengers,
      totalFare:
        requesInfo?.tripType === "Round Trip"
          ? requesInfo?.totalPassenger *
              departureTripDetail?.departureTripPrice +
            requesInfo?.totalPassenger * departureTripDetail?.returnTripPrice
          : requesInfo?.totalPassenger *
            departureTripDetail?.departureTripPrice,
      totalPaidAmount:
        requesInfo?.tripType === "Round Trip"
          ? requesInfo?.totalPassenger *
              departureTripDetail?.departureTripPrice +
            requesInfo?.totalPassenger * departureTripDetail?.returnTripPrice
          : requesInfo?.totalPassenger *
            departureTripDetail?.departureTripPrice,
      type: requesInfo?.tripType,
      paymentMethod: "",
      ispaymentdone: "Yes",
      bookedBy: "Customer",
      UsedwalletBalance: 0,
      amountToPay: 0,
      totalCashbackDiscount: 0,
      totalPriceDiscount: 0,
      tripDetails: [
        {
          tripType: "Departure",
          typeRef: "Trip",
          tripId: departureTripDetail?.departureTripId,
          noOfSeats: requesInfo?.totalPassenger,
          seats: departureTripDetail?.departureTripSeats,
          originalPrice:
            requesInfo?.totalPassenger *
            departureTripDetail?.departureTripPrice,
          price:
            requesInfo?.totalPassenger *
            departureTripDetail?.departureTripPrice,
          appliedCoupons: [],
          totalCouponDiscount: 0,
          cashbackDiscount: 0,
          priceDiscount: 0,
        },
        ...(requesInfo?.tripType === "Round Trip"
          ? [
              {
                tripType: "Return",
                typeRef: "Trip",
                tripId: departureTripDetail?.returnTripId,
                noOfSeats: requesInfo?.totalPassenger,
                seats: departureTripDetail?.returnTripSeats,
                originalPrice:
                  requesInfo?.totalPassenger *
                  departureTripDetail?.returnTripPrice,
                price:
                  requesInfo?.totalPassenger *
                  departureTripDetail?.returnTripPrice,
                appliedCoupons: [],
                totalCouponDiscount: 0,
                cashbackDiscount: 0,
                priceDiscount: 0,
              },
            ]
          : []),
      ],
    };
  });

  console.log(bookingDetail, departureTripDetail, "departureTripDetail");

  const [modifyBookingDetail, setModifyBookingDetail] = useState({
    email: departureTripDetail?.passengerDetail?.email,
    phone: `${departureTripDetail?.passengerDetail?.cCode || ""}${
      departureTripDetail?.passengerDetail?.phone || ""
    }`,
    NoOfpassengers: requesInfo?.totalPassenger,
    passengerDetails: departureTripDetail?.passengerDetail?.passengers,
    totalFare:
      requesInfo?.tripType === "Round Trip"
        ? requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice +
          requesInfo?.totalPassenger * departureTripDetail?.returnTripPrice
        : requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice,
    totalPaidAmount:
      requesInfo?.tripType === "Round Trip"
        ? requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice +
          requesInfo?.totalPassenger * departureTripDetail?.returnTripPrice
        : requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice,
    type: requesInfo?.tripType,
    tripDetails: [
      {
        tripType: "Departure",
        tripId: departureTripDetail?.departureTripId,
        noOfSeats: requesInfo?.totalPassenger,
        seats: departureTripDetail?.departureTripSeats,
        price:
          requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice,
      },
      ...(requesInfo?.tripType === "Round Trip"
        ? [
            {
              tripType: "Return",
              tripId: departureTripDetail?.returnTripId,
              noOfSeats: requesInfo?.totalPassenger,
              seats: departureTripDetail?.returnTripSeats,
              price:
                requesInfo?.totalPassenger *
                departureTripDetail?.returnTripPrice,
            },
          ]
        : []),
    ],
  });
  const [cashbackType, setCashbackType] = useState(null);
  const amountDifference =
    bookingDetail?.totalPaidAmount - oldbooking?.totalPaidAmount;
  useEffect(() => {
    setModifyBookingDetail((prevState) => ({
      ...prevState,
      tripId:
        oldbooking?.trip?._id !== departureTripDetail?.departureTripId
          ? departureTripDetail?.departureTripId
          : "",
    }));
  }, [oldbooking?.trip?._id, departureTripDetail?.departureTripId]);

  const [postCouponSubtotal, setPostCouponSubtotal] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    setPostCouponSubtotal(bookingDetail?.departurePrice);
  }, [requesInfo]);

  const saveInfo = async (e) => {
    e.preventDefault();
    setSavebooking(true);
    // Create a new FormData object
    const formData = new FormData();
    if (loggedUserId) {
      formData.append("userId", loggedUserId);
    }
    formData.append("email", bookingDetail.email);
    formData.append("phone", bookingDetail.phone);
    formData.append("NoOfpassengers", bookingDetail.NoOfpassengers);
    bookingDetail?.passengerDetails?.forEach((passenger, index) => {
      formData.append(
        `passengerDetails[${index}][firstName]`,
        passenger.firstName
      );
      formData.append(
        `passengerDetails[${index}][middleName]`,
        passenger.middleName
      );
      formData.append(
        `passengerDetails[${index}][lastName]`,
        passenger.lastName
      );
      formData.append(`passengerDetails[${index}][gender]`, passenger.gender);
      formData.append(`passengerDetails[${index}][dob]`, passenger.dob);
      formData.append(
        `passengerDetails[${index}][passportNumber]`,
        passenger.passportNumber
      );
      formData.append(`passengerDetails[${index}][country]`, passenger.country);

      // Append image file if available
      if (passenger.image) {
        formData.append(`passengerDetails[${index}][image]`, passenger.image);
      }
    });
    formData.append("totalFare", bookingDetail.totalFare);
    formData.append("totalPaidAmount", bookingDetail.totalPaidAmount);
    formData.append("DiscountedAmount", couponResponse.totalDiscount);
    formData.append("couponType", couponResponse.couponType);
    formData.append("cashbackType", cashbackType);
    formData.append("type", bookingDetail.type);
    formData.append("paymentMethod", bookingDetail.paymentMethod);
    formData.append("ispaymentdone", bookingDetail.ispaymentdone);
    formData.append("bookedBy", bookingDetail.bookedBy);
    formData.append(
      "totalCashbackDiscount",
      bookingDetail.totalCashbackDiscount
    );
    formData.append("totalPriceDiscount", bookingDetail.totalPriceDiscount);
    formData.append("walletPay", walletPay);
    bookingDetail.tripDetails.forEach((trip, index) => {
      formData.append(`tripDetails[${index}][tripType]`, trip.tripType);
      formData.append(`tripDetails[${index}][typeRef]`, trip.typeRef);
      formData.append(`tripDetails[${index}][trip]`, trip.tripId);
      formData.append(`tripDetails[${index}][noOfSeats]`, trip.noOfSeats);
      formData.append(
        `tripDetails[${index}][originalPrice]`,
        trip.originalPrice
      );
      formData.append(
        `tripDetails[${index}][totalCouponDiscount]`,
        trip.totalCouponDiscount
      );
      formData.append(
        `tripDetails[${index}][cashbackDiscount]`,
        trip.cashbackDiscount
      );
      if (trip.seats && trip.seats.length > 0) {
        trip.seats.forEach((seat, seatIndex) => {
          formData.append(`tripDetails[${index}][seats][${seatIndex}]`, seat);
        });
      } else {
        // Send empty array as a JSON string if seats is empty
        formData.append(`tripDetails[${index}][seats]`, JSON.stringify([]));
      }
      if (trip.appliedCoupons && trip.appliedCoupons.length > 0) {
        trip.appliedCoupons.forEach((coupon, cIndex) => {
          formData.append(
            `tripDetails[${index}][appliedCoupons][${cIndex}][code]`,
            coupon.code
          );
          formData.append(
            `tripDetails[${index}][appliedCoupons][${cIndex}][couponType]`,
            coupon.couponType
          );
          formData.append(
            `tripDetails[${index}][appliedCoupons][${cIndex}][percentage]`,
            coupon.percentage
          );
          formData.append(
            `tripDetails[${index}][appliedCoupons][${cIndex}][amount]`,
            coupon.amount
          );
        });
      } else {
        formData.append(
          `tripDetails[${index}][appliedCoupons]`,
          JSON.stringify([])
        );
      }
      formData.append(`tripDetails[${index}][price]`, trip.price);
    });

    // Append each passenger in the passengerDetails array

    try {
      const response = await axios.post(
        `${SERVER_URL}/bookings/bookSeatsGuest`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      Swal.fire({
        icon: "Success",
        title: "Success",
        text: response?.data?.messages?.mainMessage,
      });
      console.log("Data successfully saved:", response.data);
      await dispatch(SetCompletedBooking(response?.data?.booking));
      sessionStorage.setItem(
        "bookingDetails",
        JSON.stringify(response?.data?.booking)
      );
      dispatch(ResetBookingInfo());
      setSavebooking(false);
      if (response?.data?.updatedWalletBalance) {
        dispatch(
          updateOperatorWalletBalance(response?.data?.updatedWalletBalance)
        );
      }
      history.push("/client/order-invoice", {
        mainMessage: response?.data?.messages,
        backHome: 1,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "error",
        text: error,
      });
      setSavebooking(false);
      console.error("Error saving data:", error);
    }
  };

  const ModifyBooking = async (e) => {
    e?.preventDefault();

    // 1. Prepare FormData (matches backend expectations)
    const formData = new FormData();

    // Append basic info
    if (loggedUserId) formData.append("userId", loggedUserId);
    formData.append("email", modifyBookingDetail.email);
    formData.append("phone", modifyBookingDetail.phone);
    formData.append("NoOfpassengers", modifyBookingDetail.NoOfpassengers);

    // Append passenger details if modified
    modifyBookingDetail?.passengerDetails?.forEach((passenger, index) => {
      formData.append(
        `passengerDetails[${index}][firstName]`,
        passenger.firstName
      );
      formData.append(
        `passengerDetails[${index}][middleName]`,
        passenger.middleName || ""
      );
      formData.append(
        `passengerDetails[${index}][lastName]`,
        passenger.lastName
      );
      formData.append(`passengerDetails[${index}][gender]`, passenger.gender);
      formData.append(`passengerDetails[${index}][dob]`, passenger.dob);
      formData.append(
        `passengerDetails[${index}][passportNumber]`,
        passenger.passportNumber || ""
      );
      formData.append(
        `passengerDetails[${index}][country]`,
        passenger.country || ""
      );

      // Only append new images (skip existing URLs)
      if (passenger.image instanceof File) {
        formData.append(`passengerDetails[${index}][image]`, passenger.image);
      }
    });

    // Append trip details with seats
    modifyBookingDetail.tripDetails.forEach((trip, index) => {
      formData.append(`tripDetails[${index}][tripType]`, trip.tripType);
      formData.append(`tripDetails[${index}][tripId]`, trip.tripId);
      formData.append(`tripDetails[${index}][noOfSeats]`, trip.noOfSeats);
      formData.append(
        `tripDetails[${index}][seats]`,
        JSON.stringify(trip.seats || [])
      );
      formData.append(`tripDetails[${index}][price]`, trip.price);
    });

    // Append payment info (calculated on frontend)
    formData.append("totalFare", modifyBookingDetail.totalFare);
    formData.append("totalPaidAmount", modifyBookingDetail.totalPaidAmount);
    formData.append(
      "DiscountedAmount",
      modifyBookingDetail.DiscountedAmount || 0
    );
    formData.append("couponType", modifyBookingDetail.couponType || "");
    formData.append("cashbackType", modifyBookingDetail.cashbackType || "");
    formData.append("amountDifference", amountDifference);

    try {
      // 2. Make API call
      const response = await axios.put(
        `${SERVER_URL}/bookings/update-seats/${bookingId}`,
        formData
      );

      // 3. Handle success
      Swal.fire({
        icon: "success",
        title: "Booking Updated",
        html: `
        <div>
          <p>${response.data.message || "Booking updated successfully"}</p>
        </div>
      `,
      });

      // 4. Update global state and redirect
      await dispatch(SetCompletedBooking(response.data.booking));
      sessionStorage.setItem(
        "bookingDetails",
        JSON.stringify(response.data.booking)
      );
      dispatch(ResetBookingInfo());
      // Update wallet balance if changed
      if (response.data.updatedWalletBalance) {
        dispatch(
          updateOperatorWalletBalance(response.data.updatedWalletBalance)
        );
      }

      history.push("/client/order-invoice", {
        booking: response.data.booking,
        isModified: true,
      });
    } catch (error) {
      // 5. Handle errors
      console.error("Booking modification error:", error);

      let errorMessage = "Failed to update booking";
      if (error.response) {
        errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          JSON.stringify(error.response.data);
      }

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        html: `
        <div>
          <p>${errorMessage}</p>
          ${
            error.response?.data?.availableSeats
              ? `
            <p class="mt-2 text-sm">
              Available seats: ${error.response.data.availableSeats.join(", ")}
            </p>
          `
              : ""
          }
        </div>
      `,
      });
    }
  };

  const breadcrumbs = [
    <p>Bus Listing</p>,
    <p>Seat Selection</p>,
    <p>Passenger Detail</p>,
    <p key="3" color="text.primary" style={{ margin: "0" }}>
      Payment
    </p>,
  ];
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const handleCouponChange = (e) => {
    setCouponCode(e.target.value);
  };

  useEffect(() => {
    setBookingId(oldbooking?._id);
  }, [oldbooking]);

  const handleRemoveCoupon = (tripIndex, couponIndex) => {
    const removedCode =
      bookingDetail.tripDetails[tripIndex]?.appliedCoupons?.[couponIndex]?.code;

    setBookingDetail((prev) => {
      const tripDetails = [...prev.tripDetails];
      const trip = { ...tripDetails[tripIndex] };

      // Remove the coupon
      trip.appliedCoupons.splice(couponIndex, 1);

      // Recalculate individual discounts
      const totalCouponDiscount = trip.appliedCoupons.reduce(
        (acc, item) => acc + item.amount,
        0
      );

      const cashbackDiscount = trip.appliedCoupons
        .filter((item) => item.couponType === "cashBack")
        .reduce((acc, item) => acc + item.amount, 0);

      const priceDiscount = trip.appliedCoupons
        .filter((item) => item.couponType === "priceDiscount")
        .reduce((acc, item) => acc + item.amount, 0);

      const newPrice = parseFloat(
        (trip.originalPrice - priceDiscount).toFixed(2)
      );

      // Update trip object
      trip.totalCouponDiscount = parseFloat(totalCouponDiscount.toFixed(2));
      trip.cashbackDiscount = parseFloat(cashbackDiscount.toFixed(2));
      trip.priceDiscount = parseFloat(priceDiscount.toFixed(2)); // ✅ added
      trip.price = newPrice;

      tripDetails[tripIndex] = trip;

      // Recalculate total values across all trips
      const totalPaidAmount = tripDetails.reduce((acc, t) => acc + t.price, 0);
      const totalCashbackDiscount = tripDetails.reduce(
        (acc, t) => acc + (t.cashbackDiscount || 0),
        0
      );
      const totalPriceDiscount = tripDetails.reduce(
        (acc, t) => acc + (t.priceDiscount || 0),
        0
      ); // ✅ new total

      // ✅ Remove coupon from appliedCouponCodes if it's not used anymore
      const stillUsedAnywhere = tripDetails.some((t) =>
        t.appliedCoupons?.some((c) => c.code === removedCode)
      );

      if (!stillUsedAnywhere && removedCode) {
        setAppliedCouponCodes((prev) =>
          prev.filter((code) => code !== removedCode)
        );
      }

      return {
        ...prev,
        tripDetails,
        totalPaidAmount: parseFloat(totalPaidAmount.toFixed(2)),
        totalCashbackDiscount: parseFloat(totalCashbackDiscount.toFixed(2)),
        totalPriceDiscount: parseFloat(totalPriceDiscount.toFixed(2)), // ✅ added to state
      };
    });
  };

  // const handleApplyCoupon = async (e) => {
  //   e.preventDefault();

  //   if (!loggedUserId) {
  //     Swal.fire({
  //       title: "Login Required",
  //       text: "Please log in to apply the coupon and enjoy discounts.",
  //       icon: "warning",
  //       confirmButtonText: "OK",
  //     });
  //     return;
  //   }

  //   try {
  //     const result = await axios.post(`${SERVER_URL}/admin/check-coupon`, {
  //       couponCode: couponCode,
  //       tripType: bookingDetail?.type,
  //       trip1Id: departureTripId,
  //       trip2Id: returnTripId,
  //     });

  //     const data = result.data;

  //     if (data.isValid && data.couponType === "priceDiscount") {
  //       const originalDeparturePrice = requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice;
  //       const originalReturnPrice = requesInfo?.totalPassenger * departureTripDetail?.returnTripPrice;

  //       const discount1 = data.isValidFor1st
  //         ? parseFloat((originalDeparturePrice * (data.discountPercentage / 100)).toFixed(2))
  //         : 0;

  //       const discount2 = (bookingDetail.type === "Round Trip" && data.isValidFor2nd)
  //         ? parseFloat((originalReturnPrice * (data.discountPercentage / 100)).toFixed(2))
  //         : 0;

  //       const newDeparturePrice = parseFloat((originalDeparturePrice - discount1).toFixed(2));
  //       const newReturnPrice = parseFloat((originalReturnPrice - discount2).toFixed(2));
  //       console.log(newDeparturePrice, data, "newDeparturePrice", newReturnPrice, originalReturnPrice, originalDeparturePrice)
  //       setBookingDetail(prev => ({
  //         ...prev,
  //         tripDetails: prev.tripDetails.map((trip, i) => ({
  //           ...trip,
  //           price: i === 0 ? newDeparturePrice : i === 1 ? newReturnPrice : trip.price
  //         })),
  //         totalPaidAmount: parseFloat(
  //           (prev.type === "Round Trip"
  //             ? newDeparturePrice + newReturnPrice
  //             : newDeparturePrice
  //           ).toFixed(2)
  //         )
  //       }));
  //       setCouponResponse({
  //         discount1: discount1,
  //         discount2: discount2,
  //         couponType: data.couponType,
  //         message: data.message,
  //         totalDiscount: parseFloat((discount1 + discount2).toFixed(2))
  //       });
  //     }
  //     if (data.isValid && data.couponType === "cashBack") {
  //       const originalDeparturePrice = requesInfo?.totalPassenger * departureTripDetail?.departureTripPrice;
  //       const originalReturnPrice = requesInfo?.totalPassenger * departureTripDetail?.returnTripPrice;

  //       const discount1 = data.isValidFor1st
  //         ? parseFloat((originalDeparturePrice * (data.discountPercentage / 100)).toFixed(2))
  //         : 0;

  //       const discount2 = (bookingDetail.type === "Round Trip" && data.isValidFor2nd)
  //         ? parseFloat((originalReturnPrice * (data.discountPercentage / 100)).toFixed(2))
  //         : 0;
  //       setBookingDetail(prev => ({
  //         ...prev,
  //         tripDetails: prev.tripDetails.map((trip, i) => ({
  //           ...trip,
  //           price: i === 0 ? originalDeparturePrice : i === 1 ? originalReturnPrice : trip.price
  //         })),
  //         totalPaidAmount: parseFloat(
  //           (prev.type === "Round Trip"
  //             ? originalDeparturePrice + originalReturnPrice
  //             : originalDeparturePrice
  //           ).toFixed(2)
  //         )
  //       }));
  //       setCouponResponse({
  //         discount1: discount1,
  //         discount2: discount2,
  //         couponType: data.couponType,
  //         message: data.message,
  //         totalDiscount: parseFloat((discount1 + discount2).toFixed(2))
  //       });
  //     }
  //     Swal.fire({
  //       title: "Success",
  //       icon: "success",
  //       text: result?.data?.message,
  //     });

  //   } catch (err) {
  //     setError(err.response ? err.response.data : "Error connecting to server");
  //     console.log(err.response, "mcoupneroor")
  //     Swal.fire({
  //       title: "error",
  //       icon: "error",
  //       text: err?.response?.data?.message,
  //     });
  //   }

  // };

  useEffect(() => {
    setBookingDetail((prev) => ({
      ...prev,
      UsedwalletBalance: walletPay ? prev.totalPaidAmount : 0,
      amountToPay: walletPay ? 0 : prev.totalPaidAmount,
      paymentMethod: walletPay ? "Wallet" : "Credit/Debit",
    }));
  }, [walletPay, bookingDetail?.totalPaidAmount]);

  const handleWalletCheckbox = () => {
    if (loggedUser?.walletBalance >= bookingDetail.totalPaidAmount) {
      setWalletPay(!walletPay); // Toggle if enough balance
    } else {
      Swal.fire({
        icon: "error",
        title: "Insufficient Balance",
        text: "Your wallet balance is not enough to pay for this booking.",
        confirmButtonColor: "#d33",
      });
    }
  };

  console.log(
    requesInfo,
    "1236bookingDetail1236",
    amountDifference,
    bookingId,
    bookingDetail,
    departureTripDetail
  );
  return (
    <>
      <div className="checkOutTopWrapper">
        <Grid container className="CheckoutWrapper">
          <Grid
            container
            className="CheckoutContainer"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={11} xl={10} className="bgGrey">
              <div className="CheckoutContainerInner">
                <Grid
                  item
                  xl={7}
                  lg={7}
                  md={12}
                  sm={12}
                  xs={12}
                  className="CheckoutContainerInnerMoreInner"
                >
                  <Grid item className="title">
                    <p>
                      {languageSelectedEnglish ? "Checkout" : language.checkout}
                    </p>
                  </Grid>

                  {/* Breadcrumbs */}
                  <Grid item xs={12}>
                    <Breadcrumbs
                      separator={<NavigateNextIcon fontSize="large" />}
                      aria-label="breadcrumb"
                      className="breadCrumbs"
                    >
                      {breadcrumbs}
                    </Breadcrumbs>
                  </Grid>
                  {loggedUserId && (
                    <div className="wallteBalanceOuter">
                      <p style={{ fontWeight: "600" }}>
                        {" "}
                        Your Wallet Balance = SAR {loggedUser?.walletBalance}
                      </p>
                      <p>
                        {" "}
                        Would you like to pay from your wallet balance for this
                        booking?
                      </p>
                    </div>
                  )}
                  <div className="bookingDetailOute">
                    <div className="priceInnercal">
                      <div>
                        <strong>Operators</strong>
                      </div>
                      <div>Faisal Movers</div>
                    </div>
                    <div className="priceInnercal">
                      <div>
                        <strong>Bus Type</strong>
                      </div>
                      <div>Business Class</div>
                    </div>
                    <div className="priceInnercal">
                      <div>
                        <strong>No of Seats</strong>
                      </div>
                      <div>{totalPassenger}</div>
                    </div>
                    {isPackage && (
                      <div className="priceInnercal">
                        <div>
                          <strong>Accommodation</strong>
                        </div>
                        <div>
                          {bookingDetail?.packageWithAccom === "food" ||
                          bookingDetail?.packageWithAccom === "with" ||
                          bookingDetail?.packageWithAccom === "Visa"
                            ? "Included"
                            : "Not Included"}
                        </div>
                      </div>
                    )}
                    {isPackage && (
                      <div className="priceInnercal">
                        <div>
                          <strong>Food</strong>
                        </div>
                        <div>
                          {bookingDetail?.packageWithAccom === "food" ||
                          bookingDetail?.packageWithAccom === "Visa"
                            ? "Included"
                            : "Not Included"}
                        </div>
                      </div>
                    )}
                    {isPackage && (
                      <div className="priceInnercal">
                        <div>
                          <strong>Visa</strong>
                        </div>
                        <div>
                          {bookingDetail?.packageWithAccom === "Visa"
                            ? "Included"
                            : "Not Included"}
                        </div>
                      </div>
                    )}
                    {/* <Grid
                      item
                      sx={{ margin: "20px 0" }}
                      className="haveDiscountOuter"
                    >
                      <div style={{ display: "flex", alignItems: "center", alignSelf: "center" }}>
                        <strong>
                          {languageSelectedEnglish
                            ? "I have a discount code"
                            : language.iHaveDiscountCode}
                        </strong>
                      </div>
                      <Grid
                        item
                        className="couponCodeOuter"
                      >
                        <input
                          type="text"
                          className="promo-discount"
                          placeholder={
                            languageSelectedEnglish
                              ? "Enter Coupon Code"
                              : language.enterCouponCode
                          }
                          value={couponCode}
                          onChange={handleCouponChange}
                        />
                        <button
                          className="applyCoupnBtn"
                          onClick={handleApplyCoupon}
                        >
                          {languageSelectedEnglish
                            ? "Apply"
                            : ''}
                        </button>
                      </Grid>

                    </Grid> */}
                    <ApplyCouponUser
                      couponCode={couponCode}
                      setCouponCode={setCouponCode}
                      appliedCouponCodes={appliedCouponCodes}
                      setAppliedCouponCodes={setAppliedCouponCodes}
                      couponResponse={couponResponse}
                      setCouponResponse={setCouponResponse}
                      loggedUser={loggedUser}
                      bookingDetail={bookingDetail}
                      setBookingDetail={setBookingDetail}
                      isPackage={isPackage}
                    />
                    <div className="priceInnercal fontWeightIcr">
                      <div>
                        {requesInfo?.tripType === "Round Trip"
                          ? "Trip-1 Subtotal:"
                          : bookingDetail?.type === "Package"
                          ? "Package Subtotal:"
                          : "Subtotal:"}
                      </div>
                      <div>
                        SAR {bookingDetail?.tripDetails[0]?.originalPrice}
                      </div>
                    </div>
                    {bookingDetail?.tripDetails[0]?.appliedCoupons?.map(
                      (item, index) => (
                        <>
                          <div key={index} className="priceInnercal">
                            <div>
                              {item.couponType === "priceDiscount"
                                ? "Price Discount"
                                : "Cash Back"}{" "}
                              coupon {item.percentage}% applied:
                            </div>
                            <div>{item.amount}</div>
                          </div>
                          <button
                            onClick={() => handleRemoveCoupon(0, index)}
                            className="verifyTravlerBtn"
                          >
                            Remove
                          </button>
                        </>
                      )
                    )}
                    <div className="priceInnercal fontWeightIcr">
                      <div>
                        {" "}
                        {bookingDetail?.type == "Round Trip"
                          ? "Trip-1 Total Price Discount:"
                          : "Total Price Discount:"}
                      </div>
                      <div>{bookingDetail?.tripDetails[0]?.priceDiscount}</div>
                    </div>
                    <div className="priceInnercal fontWeightIcr">
                      <div>
                        {" "}
                        {bookingDetail?.type == "Round Trip"
                          ? "Trip-1 Total Cash Back:"
                          : "Total Cash Back:"}
                      </div>
                      <div>
                        {bookingDetail?.tripDetails[0]?.cashbackDiscount}
                      </div>
                    </div>
                    <div className="priceInnercal fontWeightIcr">
                      <div>
                        {" "}
                        {bookingDetail?.type == "Round Trip"
                          ? "Trip-1 Payable:"
                          : "Payable:"}
                      </div>
                      <div>SAR {bookingDetail?.tripDetails[0]?.price}</div>
                    </div>
                    {requesInfo?.tripType == "Round Trip" && (
                      <>
                        <div className="priceInnercal fontWeightIcr">
                          <div> Trip-2 Subtotal:</div>
                          <div>
                            SAR{bookingDetail?.tripDetails[1]?.originalPrice}
                          </div>
                        </div>
                        {bookingDetail?.tripDetails[1]?.appliedCoupons?.map(
                          (item, index) => (
                            <>
                              <div key={index} className="priceInnercal">
                                <div>
                                  {item.couponType === "priceDiscount"
                                    ? "Price Discount"
                                    : "Cash Back"}{" "}
                                  coupon {item.percentage}% applied:
                                </div>
                                <div>{item.amount}</div>
                              </div>
                              <button
                                onClick={() => handleRemoveCoupon(1, index)}
                                className="verifyTravlerBtn"
                              >
                                Remove
                              </button>
                            </>
                          )
                        )}
                        <div className="priceInnercal fontWeightIcr">
                          <div>Trip-2 Total Price Discount:</div>
                          <div>
                            {bookingDetail?.tripDetails[1]?.priceDiscount}
                          </div>
                        </div>
                        <div className="priceInnercal fontWeightIcr">
                          <div>Trip-2 Total Cash Back:</div>
                          <div>
                            {bookingDetail?.tripDetails[1]?.cashbackDiscount}
                          </div>
                        </div>
                        <div className="priceInnercal fontWeightIcr">
                          <div>Trip-2 Payable:</div>
                          <div>{bookingDetail?.tripDetails[1]?.price}</div>
                        </div>
                      </>
                    )}
                    {loggedUserId &&
                      bookingDetail?.totalCashbackDiscount > 0 && (
                        <Grid item xs={12} style={{ marginBottom: "15px" }}>
                          <div style={{ fontWeight: "600" }}>
                            Applicable cashback will be credited in your Wallet
                          </div>
                        </Grid>
                      )}
                  </div>
                </Grid>
                <div className=" lowerInnerSec">
                  <div
                    className="priceInnercal"
                    style={{ margin: "20px 0 0 0", fontSize: "1.4rem" }}
                  >
                    <div>Total Fare</div>
                    <div>SAR {bookingDetail?.totalFare}</div>
                  </div>
                  <div className="priceInnercal" style={{ fontSize: "1.4rem" }}>
                    <div>Total Price Discount</div>
                    <div>SAR {bookingDetail?.totalPriceDiscount}</div>
                  </div>
                  <div className="priceInnercal" style={{ fontSize: "1.4rem" }}>
                    <div>Total Cash Back</div>
                    <div>SAR {bookingDetail?.totalCashbackDiscount}</div>
                  </div>
                  {/* <div className="priceInnercal" style={{ fontSize: "1.4rem" }}>
                    <div >Total</div>
                    <div >SAR {bookingDetail?.totalPaidAmount}</div>
                  </div> */}
                  {loggedUserId && (
                    <div
                      className="priceInnercal"
                      style={{ fontSize: "1.4rem" }}
                    >
                      <div>Wallet Balance to be used</div>
                      <div>SAR {bookingDetail?.UsedwalletBalance}</div>
                    </div>
                  )}
                  <div className="priceInnercal" style={{ fontSize: "1.4rem" }}>
                    <div>Amount to Pay</div>
                    <div>SAR {bookingDetail?.amountToPay}</div>
                  </div>
                  {!walletPay && (
                    <p>
                      Please proceed to pay this amount via the payment options
                      below.
                    </p>
                  )}
                  {loggedUserId && (
                    <div className="paywalletInput">
                      <input
                        type="checkbox"
                        checked={walletPay}
                        onChange={handleWalletCheckbox}
                      />
                      <span>Pay from wallet balance</span>
                    </div>
                  )}
                  {!walletPay && (
                    <div className="paymentInputsOuter">
                      <Grid item xs={12} className=" cardHeading inputMargins">
                        <p>
                          {languageSelectedEnglish
                            ? "Card Information"
                            : language.cardInformation}
                        </p>
                      </Grid>

                      <Grid
                        container
                        justifyContent="space-between"
                        className="twoInputs"
                      >
                        <Grid item md={12} xl={12} lg={12}>
                          <TextField
                            style={{ width: "100%" }}
                            id="outlined-basic"
                            className="checkOutInputFields"
                            type="text"
                            label={
                              languageSelectedEnglish
                                ? "Name as displayed on Card"
                                : language.nameAsDisplayedOnCard
                            }
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>

                      {/* CVV */}
                      <Grid
                        container
                        justifyContent="space-between"
                        className="twoInputs"
                      >
                        <Grid
                          md={12}
                          xl={6}
                          lg={6}
                          item
                          sx={{ margin: "20px 0" }}
                        >
                          <TextField
                            id="outlined-basic"
                            type="text"
                            className="checkOutInputFields"
                            label="CVV"
                            variant="outlined"
                          />
                        </Grid>
                        <Grid
                          md={12}
                          xl={6}
                          lg={6}
                          item
                          sx={{ margin: "20px 0" }}
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <TextField
                            id="outlined-basic"
                            type="date"
                            className="checkOutInputFields"
                            label={
                              languageSelectedEnglish
                                ? "Expiry"
                                : language.expiry
                            }
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          type="email"
                          label={
                            languageSelectedEnglish
                              ? "Address"
                              : language.address
                          }
                          className="checkOutInputFields"
                          variant="outlined"
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ margin: "20px 0" }}>
                        <TextField
                          id="outlined-basic"
                          type="number"
                          className="checkOutInputFields"
                          label={
                            languageSelectedEnglish
                              ? "Postal Code"
                              : language.postalCode
                          }
                          variant="outlined"
                          fullWidth
                        />
                      </Grid>
                    </div>
                  )}

                  <div className="payBtnOutLeft">
                    {!isPackage && (
                      <button
                        onClick={(e) => {
                          if (modifyTrip) {
                            ModifyBooking(e);
                          } else {
                            saveInfo(e);
                          }
                        }}
                        className="payBtn"
                      >
                        {walletPay ? "Create Booking" : "Proceed to pay "}
                      </button>
                    )}
                    {isPackage && (
                      <PackageBooking
                        setSavebooking={setSavebooking}
                        couponResponse={couponResponse}
                        loggedUserId={loggedUserId}
                        bookingDetail={bookingDetail}
                        walletPay={walletPay}
                      />
                    )}
                  </div>

                  {/* <Grid
                    className="rightCardCheckout"
                    container
                    sx={{
                      border: "3px solid #C69537",
                      padding: "20px 10px",
                      color: "#000",
                      borderRadius: "10px",
                      height: "100%",
                    }}
                  >
                    <Grid container justifyContent="space-between">
                      <Grid
                        item
                        xs={12}
                        sx={{ fontSize: "2rem", color: "#0c2f54" }}
                      >
                        <p>
                          {languageSelectedEnglish
                            ? "Details"
                            : language.details}
                        </p>
                      </Grid>
                      <Grid item sx={{ margin: "30px 0" }}>
                        <Grid
                          item
                          xs={12}
                          sx={{ margin: "0px 0 10px 0", fontSize: "1.4rem" }}
                          className="CheckoutDetailHeading"
                        >
                          <p>
                            <strong>
                              {languageSelectedEnglish
                                ? "Operator"
                                : language.operators}
                            </strong>
                          </p>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                          className="CheckoutDetailHeading"
                        >
                          <p>
                            <strong>
                              {languageSelectedEnglish
                                ? "Bus Type"
                                : language.busType}
                            </strong>
                          </p>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                          className="CheckoutDetailHeading"
                        >
                          <p>
                            <strong>
                              {languageSelectedEnglish
                                ? "No of Seats"
                                : language.numberOfSeats}
                            </strong>
                          </p>
                        </Grid>
                      </Grid>
                      <Grid item sx={{ margin: "30px 0" }}>
                        <Grid
                          item
                          xs={12}
                          sx={{ marginBottom: "10px", fontSize: "1.4rem" }}
                          className="CheckoutDetailHeading"
                        >
                          <p>Faisal Movers</p>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                          className="CheckoutDetailHeading"
                        >
                          <p>
                            {languageSelectedEnglish
                              ? "Business Class"
                              : language.businessClass}
                          </p>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                          className="CheckoutDetailHeading"
                        >
                          <p>{totalPassenger}</p>
                        </Grid>
                      </Grid>
                      {!modifyTrip &&
                        <>
                          <Grid
                            item
                            xs={12}
                            sx={{ margin: "20px 0" }}
                            justifyContent="space-between"
                            display="flex"
                          >
                            <div style={{ display: "flex", alignItems: "center", alignSelf: "center" }}>
                              <label for="promo" className="checkbox-discount">
                                <strong>
                                  {languageSelectedEnglish
                                    ? "I have a discount code"
                                    : language.iHaveDiscountCode}
                                </strong>
                              </label>
                            </div>
                            <input
                              type="text"
                              className="promo-discount"
                              placeholder={
                                languageSelectedEnglish
                                  ? "Enter Coupon Code"
                                  : language.enterCouponCode
                              }
                              value={couponCode}
                              onChange={handleCouponChange}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="flex-end"
                            display="flex"
                          >
                            <button
                              className="payBtn"
                              style={{
                                padding: "8px 15px",
                                fontWeight: 600,
                                borderRadius: "5px",
                                fontSize: "14px",
                                marginTop: "-10px"
                              }}
                            >
                              {languageSelectedEnglish
                                ? "Apply"
                                : ''}
                            </button>
                          </Grid>
                          <Grid item sx={{ margin: "10px 0" }}>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "10px 0" }}
                            >
                              <p>
                                {requesInfo?.tripType == "Round Trip" ? "Trip-1 Subtotal:" : "Subtotal:"}
                              </p>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "10px 0" }}
                            >
                              <p>
                                {requesInfo?.tripType == "Round Trip" ? "Trip-1 Discount:" : "Discount:"}
                              </p>
                            </Grid>

                            {requesInfo?.tripType == "Round Trip" &&
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{ margin: "10px 0" }}
                                >
                                  <p>
                                    {languageSelectedEnglish
                                      ? "Trip-2 Subtotal:"
                                      : language.subtotal}
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{ margin: "10px 0" }}
                                >
                                  <p>
                                    {languageSelectedEnglish ? "Trip-2 Discount:" : language.tax}
                                  </p>
                                </Grid>
                              </>
                            }
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              <p>
                                {languageSelectedEnglish ? "Total" : language.total}
                              </p>
                            </Grid>
                          </Grid>
                          <Grid item sx={{ margin: "10px 0" }}>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "10px 0" }}
                            >
                              <p>SAR {bookingDetail?.tripDetails[0]?.price}</p>

                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "10px 0" }}
                            >
                              <p>{couponResponse?.discount1}</p>
                            </Grid>
                            {requesInfo?.tripType == "Round Trip" &&
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{ margin: "10px 0" }}
                                >
                                  <p>SAR {bookingDetail?.tripDetails[1]?.price}</p>

                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{ margin: "10px 0" }}
                                >
                                  <p>{couponResponse?.discount2}</p>
                                </Grid>
                              </>
                            }
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              <p>SAR {bookingDetail?.totalPaidAmount}</p>
                            </Grid>
                          </Grid>

                        </>}
                      {modifyTrip &&
                        <>
                          <Grid
                            item
                            xs={12}
                            justifyContent="flex-end"
                            display="flex"
                          >
                          </Grid>
                          <Grid item sx={{ margin: "20px 0" }}>

                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              Already Paid

                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              Current Amount
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              <div>Difference</div>
                              <div className="smallInfoText">
                                {amountDifference !== 0 && (
                                  <div className="smallInfoText">
                                    {amountDifference < 0
                                      ? "The difference will be credited to your wallet."
                                      : "An additional payment is required for this booking."}
                                  </div>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                          <Grid item sx={{ margin: "20px 0" }}>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              {oldbooking?.totalPaidAmount}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              {bookingDetail?.totalPaidAmount}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{ margin: "20px 0", fontSize: "1.4rem" }}
                            >
                              {(bookingDetail?.totalPaidAmount) - (oldbooking?.totalPaidAmount)}
                            </Grid>
                          </Grid>
                        </>
                      }
                    </Grid>
                    {loggedUserId && couponResponse?.couponType === "cashBack" && (
                      <Grid item xs={12} style={{ marginTop: "-15px", marginBottom: "15px" }}>
                        <div style={{ fontWeight: "600" }}>
                          Cashback will be credited in your Wallet
                        </div>
                      </Grid>
                    )}
                    <Grid item xs={12} align="center">
                      <div
                        onClick={(e) => {
                          if (modifyTrip) {
                            ModifyBooking(e);
                          } else {
                            saveInfo(e);
                          }
                        }}>
                        <button
                          className="payBtn"
                        >
                          Proceed to Pay
                        </button>
                      </div>
                    </Grid>
                  </Grid> */}
                </div>
                {savebooking && (
                  <div className="paymentLoaderSection">
                    <div className="bookingprocessingText">
                      Please Wait, Booking in Process...
                    </div>
                    <CircularProgress sx={{ color: "#916203" }} />
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Checkout;
